
































































































import {
  apiTradeGeneralTradePreOrder,
  ApiTradeGeneralTradePreOrderRequest,
} from '@/api'
import { computed } from '@vue/composition-api'
import { defineClassComponent, useNewRoute } from '@/hooks'
import { goodsModel } from '../store'
import { goodsProvider } from '../provider'
import { previewImage, submit } from '@/utils'
import { redirectTo } from '@/router'

export default defineClassComponent(
  () =>
    class {
      constructor() {
        useNewRoute(this.visible)
      }

      goodsData = goodsProvider.inject()

      visible = computed({
        get: () => this.goodsData.value.skuPicker.visible,
        set: visible => (this.goodsData.value.skuPicker.visible = visible),
      })

      // 点击商品图
      handleCoverClick = () => {
        previewImage({
          images: this.goodsData.value.coverPic,
        })
      }

      // 点击立即购买
      handleBuyClick = () => {
        submit(async $ => {
          $.start('正在下单...')

          const preOrderRequestData: ApiTradeGeneralTradePreOrderRequest = {
            preOrderType: 2 as any,
            skuInfo: [
              {
                commodityId: this.goodsData.value.commodityId,
                count: this.goodsData.value.buyCount,
                skuId: this.goodsData.value.commodityId,
                sellChannelId: goodsModel.state.销售渠道ID,
              },
            ],
          }
          const data = await apiTradeGeneralTradePreOrder(preOrderRequestData)
          // 弹窗进行了路由改造，直接 redirect 过去即可
          redirectTo('JointStdOrderPlace', {
            type: 'normal',
            data: JSON.stringify(data),
            preOrderRequestData: JSON.stringify(preOrderRequestData),
          })

          this.goodsData.value.closeSkuPicker()
        })
      }

      // 点击确认
      handlePureConfirmClick = async () => {
        await this.goodsData.value.skuPicker.callback?.(this.goodsData.value)
        this.goodsData.value.closeSkuPicker()
      }
    },
)
